import { render, staticRenderFns } from "./detailView.vue?vue&type=template&id=9e37c386&scoped=true&"
import script from "./detailView.vue?vue&type=script&lang=js&"
export * from "./detailView.vue?vue&type=script&lang=js&"
import style0 from "./detailView.vue?vue&type=style&index=0&id=9e37c386&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e37c386",
  null
  
)

export default component.exports